"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var KeyValueItem_1 = require("../../../../shared/controllers/KeyValueItem");
var WrapTableActions_1 = require("../../../../shared/components/table_actions/WrapTableActions");
var TableActionSelect_1 = require("../../../../shared/components/table_actions/TableActionSelect");
var ToolBarButtonsOnly_1 = require("../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarTextFilter_1 = require("../../../../shared/components/toolbars/ToolBarTextFilter");
var DlgSelectPlayer = /** @class */ (function (_super) {
    __extends(DlgSelectPlayer, _super);
    function DlgSelectPlayer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: [],
            visible: false,
            title: "",
            columnValueTitle: "Бренд",
            filter: ""
        };
        return _this;
    }
    DlgSelectPlayer.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                data: data.data,
                title: data.title,
                columnValueTitle: data.columnValueTitle,
                filter: data.filterVal
            });
        });
        this.setState({
            visible: false,
            data: [],
            title: "",
            filter: "",
            columnValueTitle: ""
        });
    };
    DlgSelectPlayer.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSelectPlayer.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: this.state.columnValueTitle,
                dataIndex: KeyValueItem_1.i_key_value_item_data_key_value,
                key: KeyValueItem_1.i_key_value_item_data_key_value,
                width: 350
            },
            {
                title: "Действия",
                key: "action",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionSelect_1.default, { hint: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C", onClick: function () {
                            if (_this.props.controller.OnSelect) {
                                _this.props.controller.OnSelect(record.key, record.value);
                            }
                        } }))); },
                align: "center",
                width: 130
            }
        ];
    };
    DlgSelectPlayer.prototype.onToolBarClick = function () {
        if (this.props.controller.onReLoadData) {
            this.props.controller.onReLoadData(this.state.filter);
        }
    };
    DlgSelectPlayer.prototype.getToolBarButton = function () {
        var _this = this;
        return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
            React.createElement(ToolBarTextFilter_1.default, { captions: { placeholder: "Логин" }, width: "120px", filterVal: this.state.filter, onFilterChanged: function (FilterVal) {
                    _this.setState({
                        filter: FilterVal
                    });
                } })));
    };
    DlgSelectPlayer.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.title, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: true, maskClosable: false, footer: React.createElement("div", null), onCancel: function () {
                if (_this.props.controller.onClose) {
                    _this.props.controller.onClose();
                }
            } },
            React.createElement("div", null,
                this.getToolBarButton(),
                React.createElement(antd_1.Table, { columns: this.getColumns(), dataSource: this.state.data, size: "small", pagination: {
                        pageSize: 10,
                        showSizeChanger: false,
                        position: "bottom",
                        showQuickJumper: false
                    } }))));
    };
    return DlgSelectPlayer;
}(React.Component));
exports.default = DlgSelectPlayer;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSelectPlayer.tsx
// module id = 2499
// module chunks = 0